import React, { useState } from "react";
import LearningExcellence from "../../components/User/Home/LearningExcellence";
import CollabCourse from "../../components/User/Home/CollabCourse";
// import OnlineCourses from "../../components/User/Home/OnlineCourses";
import Counter from "../../components/AboutComponent/Counter";
import JoinUs from "../../components/User/Home/JoinUs";
import Testimonial from "../../components/User/Home/Testimonials";
import Hero from "../../components/User/Home/Hero";
import Card from "../../components/User/Home/Card";
import WhatsAppChat from "../../components/common/Whatsapp";
import DemoRegistrationTab from "../../components/common/DemoRegistrationTab";
import DemoClassRegistrationModal from "../../components/common/DemoClassRegistrationModal";
import PlacementSection from "../../components/User/Home/PlacementSection";

const Home = () => {
  // const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  return (
    <React.Fragment>
      <div className="overflow-hidden">
        {/* <WhatsAppChat/> */}
        <LearningExcellence />
        {/* <DemoRegistrationTab onClick={() => setIsDemoModalOpen(true)}/> */}
        <Card />
        <Testimonial />
        <PlacementSection />
        <CollabCourse />
        <Counter />
        {/* <OnlineCourses /> */}
        <JoinUs />
        <Hero />
      </div>

      {/* <DemoClassRegistrationModal
        isOpen={isDemoModalOpen}
        onClose={() => setIsDemoModalOpen(false)}
      /> */}
    </React.Fragment>
  );
};

export default Home;
